import React, {Component} from 'react';
import PropTypes from 'prop-types';
import User from 'react-feather/dist/icons/user.js';
import HelpCircle from 'react-feather/dist/icons/help-circle.js';
import Tooltip from 'rc-tooltip';

import conf from '../../../../conf.js';

import './Results.scss';

export default class Results extends Component {
  static defaultProps = {
    nbResults: 0,
    nbActive: 0,
    className: ''
  };

  static propTypes = {
    nb: PropTypes.number,
    className: PropTypes.string
  };

  render() {
    const results = this.props.nbResults + ' consultant' + (this.props.nbResults > 1 ? 's' : '');

    return (
      <div className="results">
        <User className="icon icon-user"/>
        <div className="nb text-center">{`${results} / ${this.props.nbActive} actifs`}</div>
        <Tooltip
          placement="top"
          trigger={['hover']}
          overlay={
            <span className="text-center">
              De nombreux profils ne sont pas publics !<br/>
              Détaillez nous votre besoin au <a href={`tel:${conf.site.phone}`} style={{color: 'white'}}>{conf.site.phone}</a>,
              et nous vous transmettrons des profils complémentaires !
            </span>
          }
        >
          <HelpCircle className="icon icon-help"/>
        </Tooltip>
      </div>
    );
  }
}